import RegisteredBlockType from '@orgnc/core/components/blocks/Blocks/types';
import { IArticle } from '@orgnc/core/lib/wordpress/api/adapters/articleAdapter';

export const injectAdToBlocks = (
  blocks: IArticle['blocks']
): IArticle['blocks'] => {
  const result: IArticle['blocks'] = [];
  const adBlock = {
    name: 'acf/htl-ad',
    order: -1,
    unit: 'MedRec_Content',
    hasBaseHeight: false,
    attributes: {},
    innerBlocks: [],
  };

  const paragraphIndexes = blocks
    .map((block, index) => {
      return block.name === RegisteredBlockType.CoreParagraphBlock ? index : -1;
    })
    .filter((x) => x >= 0);

  const insertAdAfterParagraphIndexes: number[] = [];

  paragraphIndexes.forEach((paragraphIdx, index, arr) => {
    // second paragraph or last
    if (index === 1 || (index > 1 && index === arr.length - 2)) {
      insertAdAfterParagraphIndexes.push(paragraphIdx);
    }
  });

  if (!paragraphIndexes.length) {
    return blocks;
  }

  blocks.forEach((block, index) => {
    if (insertAdAfterParagraphIndexes.includes(index)) {
      result.push(...[block, { ...adBlock }]);
    } else {
      result.push(block);
    }
  });

  // reindex blocks
  return result.map((block, index) => ({
    ...block,
    order: index,
  }));
};

export const injectAds = (article: IArticle): IArticle => {
  const stripEmptyParagraphs = (
    blocks: IArticle['blocks']
  ): IArticle['blocks'] => {
    let lastContentfulParagraphIndex = 0;
    blocks.forEach((block, index) => {
      if (
        block.name === RegisteredBlockType.CoreParagraphBlock &&
        block.originalContent !== '<p></p>'
      ) {
        lastContentfulParagraphIndex = index;
      }
    });
    // strip all empty paragraphs after last contentful paragraph
    return blocks.filter((block, index) => {
      return !(
        block.name === RegisteredBlockType.CoreParagraphBlock &&
        index > lastContentfulParagraphIndex &&
        block.originalContent === '<p></p>'
      );
    });
  };

  const filteredBlocks = stripEmptyParagraphs(article.blocks);

  return {
    ...article,
    blocks: injectAdToBlocks(filteredBlocks),
  };
};
